var _path, _path2, _circle, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSaveMoneyAndTimeOrange = function SvgSaveMoneyAndTimeOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M47 16.8V33l8.64 5.4M29.114 22.489l-8.072 3.082L17.96 17.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M56.632 58.224c13.923-5.317 20.908-20.932 15.592-34.856C66.907 9.445 51.292 2.46 37.368 7.776c-8.256 3.153-14.056 9.915-16.326 17.795"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 54,
    r: 20,
    fill: "url(#save-money-and-time-orange_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M29 48v-1a3 3 0 1 0-6 0v2.838A4.387 4.387 0 0 0 26 54c1.792.597 3 2.274 3 4.162V61a3 3 0 1 1-6 0v-1M26 42v2M26 64v2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-money-and-time-orange_svg__a",
    x1: 46.488,
    x2: 5.979,
    y1: 53.382,
    y2: 53.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BE60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BE60",
    stopOpacity: 0.2
  })))));
};
export default SvgSaveMoneyAndTimeOrange;